/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as Highcharts from 'highcharts';

export function applyHighchartsLocale($locale: any, networkTimezoneOffset: number): void {
  Highcharts.setOptions({
    // v11+ moved timezoneOffset off deprecated global.* into time.*
    time: {timezoneOffset: networkTimezoneOffset * -1},
    lang: {
      // v12 defaults date labels to html/browser locale; pin to the app locale.
      locale: $locale.id || 'en-GB',
      shortMonths: $locale.DATETIME_FORMATS.SHORTMONTH,
      months: $locale.DATETIME_FORMATS.MONTH,
      weekdays: $locale.DATETIME_FORMATS.DAY,
      thousandsSep: $locale.NUMBER_FORMATS.GROUP_SEP || ' ',
      decimalPoint: $locale.NUMBER_FORMATS.DECIMAL_SEP || '.'
    }
  });
}

export function chunkYValue(yval: any): number {
  if (yval?.amount !== undefined) {
    return yval.amount;
  }
  if (yval?.count !== undefined) {
    return yval.count;
  }
  return yval;
}
